import { Link } from "react-router-dom";
import { hotArticles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import { siteConfig, siteStats } from "@/mocks/site";
import { formatNumber } from "@/lib/content";

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-background-50 border-b border-background-200">
      <div className="absolute -top-28 -right-24 w-96 h-96 rounded-full bg-accent-100/60 blur-3xl pointer-events-none"></div>
      <div className="absolute -bottom-32 -left-20 w-80 h-80 rounded-full bg-primary-100/50 blur-3xl pointer-events-none"></div>

      <div className="relative mx-auto w-full max-w-[1240px] px-4 md:px-6 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          <div className="lg:col-span-7 anim-fade-up">
            <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-100 border border-background-300 text-xs text-foreground-700">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 anim-pulse-dot"></span>
              2026 年 9 月 12 日 · 今日看点已更新
            </p>
            <h1 className="mt-5 font-heading text-3xl sm:text-4xl md:text-5xl leading-[1.25] text-foreground-950">
              {siteConfig.name}
              <span className="text-primary-600">每日精选</span>
              <br className="hidden sm:block" />
              一页看完当日看点精华
            </h1>
            <p className="mt-5 max-w-xl text-sm md:text-base leading-relaxed text-foreground-600">
              {siteConfig.description} 综艺名场面、影视热剧、网络热点与明星动态，每天早晚两次为你筛好，点开就是今天最值得看的内容。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to="/today"
                className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看今日必看
              </Link>
              <Link
                to="/topics"
                className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md border border-background-300 bg-background-50 text-foreground-900 text-sm font-medium whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
              >
                <i className="ri-layout-grid-line"></i>
                浏览主题分类
              </Link>
            </div>

            <div className="mt-9 flex flex-wrap gap-x-8 gap-y-4">
              {siteStats.slice(0, 3).map((item) => (
                <div key={item.label}>
                  <p className="font-heading text-2xl text-foreground-950">{item.value}</p>
                  <p className="mt-0.5 text-xs text-foreground-500">{item.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-2">
              <span className="text-xs text-foreground-500 mr-1">快捷入口</span>
              {categories.slice(0, 5).map((item) => (
                <Link
                  key={item.slug}
                  to={`/topic/${item.slug}`}
                  className="px-3 py-1 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-5 w-full anim-fade-up">
            <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
              <div className="flex items-center justify-between pb-3 border-b border-background-200">
                <h2 className="flex items-center gap-2 text-base font-semibold text-foreground-950">
                  <i className="ri-flashlight-line text-accent-600"></i>
                  今日看点速览
                </h2>
                <span className="text-xs text-foreground-500">08:00 更新</span>
              </div>
              <ul className="mt-1 divide-y divide-background-200">
                {hotArticles.map((item, index) => (
                  <li key={item.id} className="group flex items-start gap-3 py-3.5">
                    <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-md bg-background-100 text-sm font-semibold text-foreground-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                      {index + 1}
                    </span>
                    <div className="min-w-0">
                      <Link
                        to={`/article/${item.id}`}
                        className="text-sm leading-relaxed text-foreground-900 group-hover:text-primary-700 transition-colors line-clamp-2"
                      >
                        {item.title}
                      </Link>
                      <p className="mt-1 text-xs text-foreground-500 flex items-center gap-3">
                        <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{formatNumber(item.views)}</span>
                        <span>{item.readTime}</span>
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
              <Link
                to="/today"
                className="mt-3 flex items-center justify-center gap-1.5 h-10 rounded-md bg-background-100 text-sm text-foreground-900 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                查看全部今日看点
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="mt-4 rounded-lg bg-secondary-950 p-5 text-background-100">
              <p className="text-xs text-accent-300 tracking-wide">看点日报</p>
              <p className="mt-2 text-sm leading-relaxed text-background-100/90">
                每天早上把精选看点清单发到你的邮箱，不用自己翻热搜。
              </p>
              <a
                href="#newsletter"
                className="mt-3 inline-flex items-center gap-1.5 text-sm text-accent-300 hover:text-accent-200 transition-colors"
              >
                立即订阅 <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}